(function () {
  'use strict';

  var SIZES = ['XXS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL'];

  var state = {
    currentStep: 0,
    heightFeet: null,
    heightInches: null,
    weight: null,
    showResult: false
  };

  var els = {};

  function getRecommendedSize(heightDecimal, weightLbs) {
    var baseSize;

    if (heightDecimal < 5.33) {
      if (weightLbs < 110) baseSize = 'XXS';
      else if (weightLbs < 130) baseSize = 'XS';
      else if (weightLbs < 150) baseSize = 'S';
      else if (weightLbs < 170) baseSize = 'M';
      else if (weightLbs < 200) baseSize = 'L';
      else if (weightLbs < 230) baseSize = 'XL';
      else if (weightLbs < 270) baseSize = '2XL';
      else if (weightLbs < 310) baseSize = '3XL';
      else baseSize = '4XL';
    } else if (heightDecimal < 5.67) {
      if (weightLbs < 120) baseSize = 'XS';
      else if (weightLbs < 145) baseSize = 'S';
      else if (weightLbs < 170) baseSize = 'M';
      else if (weightLbs < 200) baseSize = 'L';
      else if (weightLbs < 235) baseSize = 'XL';
      else if (weightLbs < 275) baseSize = '2XL';
      else if (weightLbs < 320) baseSize = '3XL';
      else baseSize = '4XL';
    } else if (heightDecimal < 6.0) {
      if (weightLbs < 130) baseSize = 'S';
      else if (weightLbs < 160) baseSize = 'M';
      else if (weightLbs < 190) baseSize = 'L';
      else if (weightLbs < 225) baseSize = 'XL';
      else if (weightLbs < 265) baseSize = '2XL';
      else if (weightLbs < 310) baseSize = '3XL';
      else baseSize = '4XL';
    } else {
      if (weightLbs < 150) baseSize = 'M';
      else if (weightLbs < 180) baseSize = 'L';
      else if (weightLbs < 215) baseSize = 'XL';
      else if (weightLbs < 260) baseSize = '2XL';
      else if (weightLbs < 310) baseSize = '3XL';
      else baseSize = '4XL';
    }

    return baseSize;
  }

  function trackEvent(eventName, data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, data || {}));
  }

  function cacheElements() {
    els.modal = document.getElementById('size-quiz-modal');
    els.tabQuiz = document.getElementById('sq-tab-quiz');
    els.tabChart = document.getElementById('sq-tab-chart');
    els.panelQuiz = document.getElementById('sq-panel-quiz');
    els.panelChart = document.getElementById('sq-panel-chart');
    els.progress = document.getElementById('sq-progress');
    els.progressText = document.getElementById('sq-progress-text');
    els.progressPct = document.getElementById('sq-progress-pct');
    els.progressFill = document.getElementById('sq-progress-fill');
    els.steps = [
      document.getElementById('sq-step-0'),
      document.getElementById('sq-step-1')
    ];
    els.result = document.getElementById('sq-result');
    els.feet = document.getElementById('sq-feet');
    els.inches = document.getElementById('sq-inches');
    els.weight = document.getElementById('sq-weight');
    els.heightConfirm = document.getElementById('sq-height-confirm');
    els.weightConfirm = document.getElementById('sq-weight-confirm');
    els.resultSize = document.getElementById('sq-result-size');
    els.resultSizeText = document.getElementById('sq-result-size-text');
    els.resultExplanation = document.getElementById('sq-result-explanation');
    els.shopSize = document.getElementById('sq-shop-size');
    els.retake = document.getElementById('sq-retake');
    els.nav = document.getElementById('sq-nav');
    els.back = document.getElementById('sq-back');
    els.next = document.getElementById('sq-next');
    els.chartTakeQuiz = document.getElementById('sq-chart-take-quiz');
  }

  function isStepValid(step) {
    if (step === 0) {
      return state.heightFeet !== null && state.heightInches !== null;
    }
    if (step === 1) {
      return state.weight !== null && state.weight >= 80 && state.weight <= 500;
    }
    return false;
  }

  function updateNavButtons() {
    els.back.disabled = state.currentStep === 0;
    els.back.style.visibility = state.currentStep === 0 ? 'hidden' : 'visible';
    els.next.disabled = !isStepValid(state.currentStep);
    els.next.textContent = state.currentStep === 1 ? 'See My Size' : 'Next →';
  }

  function updateProgress() {
    var step = state.currentStep + 1;
    var pct = Math.round((step / 2) * 100);
    els.progressText.textContent = 'Step ' + step + ' of 2';
    els.progressPct.textContent = pct + '%';
    els.progressFill.style.width = pct + '%';
  }

  function showStep(n) {
    state.currentStep = n;
    state.showResult = false;

    els.steps.forEach(function (step) {
      step.classList.add('sq-step--hidden');
    });
    els.result.classList.add('sq-step--hidden');
    els.steps[n].classList.remove('sq-step--hidden');

    els.progress.style.display = '';
    els.nav.style.display = '';

    updateProgress();
    updateNavButtons();
  }

  function highlightChartRow(size) {
    var rows = document.querySelectorAll('.sq-chart tbody tr');
    rows.forEach(function (row) {
      row.classList.remove('sq-chart-highlight');
    });
    if (size) {
      var match = document.querySelector('.sq-chart tbody tr[data-size="' + size + '"]');
      if (match) match.classList.add('sq-chart-highlight');
    }
  }

  function showResultScreen() {
    state.showResult = true;

    var heightDecimal = state.heightFeet + state.heightInches / 12;
    var size = getRecommendedSize(heightDecimal, state.weight);

    els.steps.forEach(function (step) {
      step.classList.add('sq-step--hidden');
    });
    els.result.classList.remove('sq-step--hidden');

    els.resultSize.textContent = size;
    els.resultSizeText.textContent = size;
    els.resultExplanation.textContent =
      "Based on your height (" + state.heightFeet + "'" + state.heightInches + '") and weight (' + state.weight + ' lbs).';
    els.progress.style.display = 'none';
    els.nav.style.display = 'none';

    try {
      localStorage.setItem('swoveralls_recommended_size', size);
      localStorage.setItem(
        'swoveralls_quiz_data',
        JSON.stringify({
          heightFeet: state.heightFeet,
          heightInches: state.heightInches,
          weight: state.weight
        })
      );
    } catch (e) {}

    highlightChartRow(size);
    updateTriggerText(size);

    trackEvent('size_quiz_complete', {
      recommendedSize: size,
      height: state.heightFeet + "'" + state.heightInches + '"',
      weight: state.weight
    });
  }

  function nextStep() {
    if (!isStepValid(state.currentStep)) return;

    trackEvent('size_quiz_step', {
      step: state.currentStep,
      height: state.heightFeet !== null ? state.heightFeet + "'" + state.heightInches + '"' : null,
      weight: state.weight
    });

    if (state.currentStep === 1) {
      showResultScreen();
    } else {
      showStep(state.currentStep + 1);
    }
  }

  function prevStep() {
    if (state.currentStep > 0) {
      showStep(state.currentStep - 1);
    }
  }

  function resetQuiz() {
    var previousSize = null;
    try {
      previousSize = localStorage.getItem('swoveralls_recommended_size');
      localStorage.removeItem('swoveralls_recommended_size');
      localStorage.removeItem('swoveralls_quiz_data');
    } catch (e) {}

    state.heightFeet = null;
    state.heightInches = null;
    state.weight = null;
    state.showResult = false;

    els.feet.selectedIndex = 0;
    els.inches.selectedIndex = 0;
    els.weight.value = '';
    els.heightConfirm.hidden = true;
    els.weightConfirm.hidden = true;

    highlightChartRow(null);
    updateTriggerText(null);
    showStep(0);

    if (previousSize) {
      trackEvent('size_quiz_retake', { previousSize: previousSize });
    }
  }

  function switchTab(tab) {
    if (tab === 'quiz') {
      els.tabQuiz.classList.add('sq-tab--active');
      els.tabQuiz.setAttribute('aria-selected', 'true');
      els.tabChart.classList.remove('sq-tab--active');
      els.tabChart.setAttribute('aria-selected', 'false');
      els.panelQuiz.classList.remove('sq-panel--hidden');
      els.panelChart.classList.add('sq-panel--hidden');
    } else {
      els.tabChart.classList.add('sq-tab--active');
      els.tabChart.setAttribute('aria-selected', 'true');
      els.tabQuiz.classList.remove('sq-tab--active');
      els.tabQuiz.setAttribute('aria-selected', 'false');
      els.panelChart.classList.remove('sq-panel--hidden');
      els.panelQuiz.classList.add('sq-panel--hidden');
    }
  }

  function updateTriggerText(size) {
    var triggers = document.querySelectorAll('.sq-trigger__text');
    for (var i = 0; i < triggers.length; i++) {
      if (size) {
        triggers[i].textContent = 'Your size: ' + size + ' — Retake?';
      } else {
        triggers[i].textContent = 'Not sure? Find Your Size';
      }
    }
  }

  function open(options) {
    if (!els.modal) return;
    var tab = (options && options.tab) || 'quiz';
    switchTab(tab);
    els.modal.showModal();
    trackEvent('size_quiz_open', {});
  }

  function close() {
    if (!els.modal) return;
    var storedSize = getStoredSize();
    els.modal.close();
    setTimeout(function () {
      if (!state.showResult) {
        resetQuiz();
      }
      if (storedSize) {
        updateTriggerText(storedSize);
      }
    }, 300);
  }

  function getStoredSize() {
    try {
      return localStorage.getItem('swoveralls_recommended_size');
    } catch (e) {
      return null;
    }
  }

  window.SwoverallsSizeQuiz = {
    open: open,
    close: close,
    getStoredSize: getStoredSize
  };

  document.addEventListener('DOMContentLoaded', function () {
    cacheElements();
    if (!els.modal) return;

    // Tab click handlers
    els.tabQuiz.addEventListener('click', function () { switchTab('quiz'); });
    els.tabChart.addEventListener('click', function () { switchTab('chart'); });

    // Tab keyboard navigation (arrow keys)
    var tabs = [els.tabQuiz, els.tabChart];
    tabs.forEach(function (tab, i) {
      tab.addEventListener('keydown', function (e) {
        var next;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          next = tabs[(i + 1) % tabs.length];
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          next = tabs[(i - 1 + tabs.length) % tabs.length];
        }
        if (next) {
          e.preventDefault();
          next.click();
          next.focus();
        }
      });
    });

    // Height selects
    els.feet.addEventListener('change', function () {
      state.heightFeet = parseInt(this.value, 10);
      updateHeightConfirm();
      updateNavButtons();
    });

    els.inches.addEventListener('change', function () {
      state.heightInches = parseInt(this.value, 10);
      updateHeightConfirm();
      updateNavButtons();
    });

    function updateHeightConfirm() {
      if (state.heightFeet !== null && state.heightInches !== null) {
        els.heightConfirm.textContent = "You're " + state.heightFeet + "'" + state.heightInches + '" tall';
        els.heightConfirm.hidden = false;
      }
    }

    // Weight input
    els.weight.addEventListener('input', function () {
      var val = parseInt(this.value, 10);
      state.weight = isNaN(val) ? null : val;
      if (state.weight !== null && state.weight >= 80 && state.weight <= 500) {
        els.weightConfirm.textContent = state.weight + ' lbs';
        els.weightConfirm.hidden = false;
      } else {
        els.weightConfirm.hidden = true;
      }
      updateNavButtons();
    });

    // Nav buttons
    els.next.addEventListener('click', nextStep);
    els.back.addEventListener('click', prevStep);

    // Result actions
    els.retake.addEventListener('click', resetQuiz);
    els.shopSize.addEventListener('click', function () {
      trackEvent('size_quiz_shop_size', { recommendedSize: getStoredSize() });
      close();
    });

    // Chart take quiz button
    els.chartTakeQuiz.addEventListener('click', function () {
      switchTab('quiz');
    });

    // Dialog close event (Escape key or backdrop click)
    els.modal.addEventListener('close', function () {
      setTimeout(function () {
        if (!state.showResult) {
          resetQuiz();
        }
      }, 300);
    });

    // Backdrop click to close
    els.modal.addEventListener('click', function (e) {
      if (e.target === els.modal) {
        close();
      }
    });

    // Bind all trigger elements
    document.querySelectorAll('[data-size-quiz-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    });

    // Bind kids size chart triggers
    document.querySelectorAll('[data-size-chart-kids-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        var kidsModal = document.getElementById('size-chart-kids-modal');
        if (kidsModal) kidsModal.showModal();
      });
    });

    // Close kids modal on backdrop click
    var kidsModal = document.getElementById('size-chart-kids-modal');
    if (kidsModal) {
      kidsModal.addEventListener('click', function (e) {
        if (e.target === kidsModal) kidsModal.close();
      });
    }

    // Open modal from any link with href="#size-quiz"
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href="#size-quiz"]');
      if (link) {
        e.preventDefault();
        open();
      }
    });

    // Check localStorage for stored size
    var storedSize = getStoredSize();
    if (storedSize) {
      highlightChartRow(storedSize);
      updateTriggerText(storedSize);
    }
  });
})();
